//App.js
import { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './App.css';
import VillageDetails from './VillageDetails'; 
import MessageDetails from './MessageDetails'; 

const samanyaPanel = () => <div className="panel">सामान्य प्रशासन विभाग</div>;
const gharkulPanel = () => <div className="panel">घरकुल विभाग</div>;
const evadPanel = () => <div className="panel">इ. व द. विभाग</div>;
const arogyaPanel = () => <div className="panel">आरोग्य विभाग</div>;
const graminpaniPanel = () => <div className="panel">ग्रामीण पाणी पुरवठा विभाग</div>;
const shikshanPanel = () => <div className="panel">शिक्षण विभाग</div>;
const jivannottiPanel = () => <div className="panel">महाराष्ट्र राज्य ग्रामीण जीवननोत्ती विभाग</div>;
const gpPanel = () => <div className="panel">ग्रामपंचायत विभाग</div>;
const swachhPanel = () => <div className="panel">स्वच्छ भारत मिशन</div>;
const pashuPanel = () => <div className="panel">पशुसंवर्धन विभाग</div>;
const samajPanel = () => <div className="panel">समाज कल्याण विभाग</div>;
const krushiPanel = () => <div className="panel">कृषि विभाग</div>;
const SchemesPanel = () => <div className="panel">विविध शासकीय योजना </div>;

const TabButton = ({ icon, label, active, onClick }) => (
  <button className={`tab-button ${active ? 'active' : ''}`} onClick={onClick}>
    <span className="material-icons">{icon}</span>
    <span className="tab-label">{label}</span>
  </button>
);

const panelVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 },
};

function App() {
  const gaonSrNo = 135;

  const [darkMode, setDarkMode] = useState(() => localStorage.getItem('darkMode') === 'true');
  const [visitCount, setVisitCount] = useState(null);
  const [visitorCount, setVisitorCount] = useState(null);
  const hasUpdated = useRef(false);

  const handleShare = () => {
    const text = encodeURIComponent("आपल्या तालुक्याची सारी माहिती आता एका ठिकाणी! www.panchaytsamitidindori.co.in 🚀 आपल्या गावाची डिजिटल ओळख. सर्वांना शेअर करा.");
    window.open(`https://wa.me/?text=${text}`, "_blank");
  };

  useEffect(() => {
    localStorage.setItem('darkMode', darkMode);
  }, [darkMode]);

  useEffect(() => {
    if (!hasUpdated.current) {
      hasUpdated.current = true;
      fetch(`https://mazagaon.co.in/api/visit_counter.php?gaonSrNo=${gaonSrNo}`)
        .then(res => res.json())
        .then(data => {
          if (data.visits !== undefined) setVisitCount(data.visits);
          if (data.visitors !== undefined) setVisitorCount(data.visitors);
        })
        .catch(err => console.error('Visit count error:', err));
    }
  }, [gaonSrNo]);

  const [highlightSuchana, setHighlightSuchana] = useState('');

  useEffect(() => {
    fetch(`https://mazagaon.co.in/api/get_highlight_suchana.php?gaonSrNo=${gaonSrNo}`)
      .then(res => res.json())
      .then(data => {
        if (data.Highlight_Suchana) {
          setHighlightSuchana(data.Highlight_Suchana);
        }
      })
      .catch(err => console.error('Highlight Suchana error:', err));
  }, [gaonSrNo]);

  const [activeTab, setActiveTab] = useState(() => localStorage.getItem('activeTab') || 'events');

  useEffect(() => {
    localStorage.setItem('activeTab', activeTab);
  }, [activeTab]);

  const renderPanel = () => {
    switch (activeTab) {
      case 'samanya': return <samanyaPanel />;
      case 'gharkul': return <gharkulPanel />;
      case 'evad': return <evadPanel />;
      case 'arogya': return <arogyaPanel />;
      case 'graminpani': return <graminpaniPanel />;
      case 'shikahan': return <shikshanPanel />;
      case 'jivannotti': return <jivannottiPanel />;
      case 'gp': return <gpPanel />;
      case 'swachh': return <swachhPanel />;
      case 'pashu': return <pashuPanel />;
      case 'samaj': return <samajPanel />;
      case 'krushi': return <krushiPanel />;
      case 'schemes': return <SchemesPanel />;
      
      default: return null;
    }
  };

  
  return (
    <div className={`app-container ${darkMode ? 'dark' : ''}`}>
      <div className="theme-toggle">
        <button onClick={() => setDarkMode(!darkMode)}>
          {darkMode ? '🌞 लाइट मोड' : '🌙 डार्क मोड'}
        </button>
      </div>

        <div className="visit-counter">👁️ Visits: {visitCount ?? '...'}</div>
        <div className="unique-visitor">👥Visitors: {visitorCount ?? '...'}</div>

      <div className='sharelink btn' onClick={handleShare}>
        <span className='sharesymbol'>⤴️</span>
        Share
      </div>

      <div className="main-content">
        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            initial="hidden"
            animate="visible"
            exit="exit"
            variants={panelVariants}
            transition={{ duration: 0.3 }}
          >
            {renderPanel()}
            {activeTab === 'about' && <VillageDetails gaonSrNo={gaonSrNo} />}
            {['samanya', 'gharkul', 'evad', 'arogya', 'graminpani', 'shikahan', 'jivannotti', 'gp', 'swachh', 'pashu', 'samaj', 'krushi', 'schemes'].includes(activeTab) && (
              <MessageDetails gaonSrNo={gaonSrNo} curtab={activeTab} />
            )}


          </motion.div>
        </AnimatePresence>
      </div>

      {highlightSuchana && (
        <div className="scrolling-suchana">
          <div className="scrolling-text">📢 <b>ठळक सूचना:</b> {highlightSuchana}</div>
        </div>
      )}

      <div className="bottom-tabs">
        <TabButton icon="🏛️" label="पं. समिती" active={activeTab === 'about'} onClick={() => setActiveTab('about')} />
        <TabButton icon="🖼️" label="सामान्य प्रशासन" active={activeTab === 'samanya'} onClick={() => setActiveTab('samanya')} />
        <TabButton icon="🎉" label="घरकुल" active={activeTab === 'gharkul'} onClick={() => setActiveTab('gharkul')} />
        <TabButton icon="📺" label="इ.व द." active={activeTab === 'evad'} onClick={() => setActiveTab('evad')} />
        <TabButton icon="🦸🏼" label="आरोग्य" active={activeTab === 'arogya'} onClick={() => setActiveTab('arogya')} />
        <TabButton icon="📆" label="ग्रा.पाणी पुरवठा" active={activeTab === 'graminpani'} onClick={() => setActiveTab('graminpani')} />
        <TabButton icon="🪪" label="शिक्षण" active={activeTab === 'shikahan'} onClick={() => setActiveTab('shikahan')} />
        <TabButton icon="🪪" label="जीवननोत्ती" active={activeTab === 'jivannotti'} onClick={() => setActiveTab('jivannotti')} />
        <TabButton icon="🪪" label="ग्रामपंचायत" active={activeTab === 'gp'} onClick={() => setActiveTab('gp')} />
        <TabButton icon="🪪" label="स्वच्छ भारत मिशन" active={activeTab === 'swachh'} onClick={() => setActiveTab('swachh')} />
        <TabButton icon="🪪" label="पशुसंवर्धन" active={activeTab === 'pashu'} onClick={() => setActiveTab('pashu')} />
        <TabButton icon="🪪" label="समाज कल्याण" active={activeTab === 'samaj'} onClick={() => setActiveTab('samaj')} />
        <TabButton icon="🪪" label="कृषि विभाग" active={activeTab === 'krushi'} onClick={() => setActiveTab('krushi')} />
        <TabButton icon="📆" label="योजना" active={activeTab === 'schemes'} onClick={() => setActiveTab('schemes')} />

      </div>

      <div className="bottom-title">
        <h6 className="gtitle">पंचायत समिती दिंडोरी</h6>
      </div>
    </div>
  );
}

export default App;
